<ng-vessel-event-dialog
  *ngIf="(store$ | async) as store"
  [event]="store.data"
  [loading]="store.loading">
</ng-vessel-event-dialog>
